// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3jZc6","loaderOuter":"PageOverlayLoader_loaderOuter__HJbDC"};